export const buildUpdateRequest = (data: any): any => {
  return {
    startTime: data.startTime,
    endTime: data.endTime,
    acceptsRecurringProducts: data.acceptsRecurringProducts,
    discountApprovalMode: data.discountApprovalMode,
    ...(data.foreignerRegistrationsLimit && {
      foreignerRegistrationsLimit: Number(data.foreignerRegistrationsLimit),
    }),
    ...(data.gatewayCashier && {
      gatewayCashier: data.gatewayCashier,
    }),
    ...(data.gatewayHash && {
      gatewayHash: data.gatewayHash,
    }),
    ...(data.cieloMerchantId && {
      cieloMerchantId: data.cieloMerchantId,
    }),
    ...(data.cieloMerchantKey && {
      cieloMerchantKey: data.cieloMerchantKey,
    }),
  }
}
